import React from "react";

import { LOADING_STATE } from "@typings/reduxThunkActions";

import { ErrorBoundary } from "@ui/Atoms/ErrorBoundary";

import { useAuth } from "@hooks/useAuth";
import {
  useFeatureToggle,
  useFeatureToggleManager,
} from "@hooks/useFeatureToggle";
import { useTranslate } from "@hooks/useTranslate";

import { Props } from "./HomeCleaningCTA.types";

const HomeCleaningCTA = React.lazy(() => import("./HomeCleaningCTA"));

export const HomeCleaningCTALazy: React.FC<Props> = (
  props,
): React.ReactElement | null => {
  const { isUserStateKnown, isUserLoggedIn } = useAuth();
  const { status: featureToggleStatus } = useFeatureToggleManager();
  const translate = useTranslate("batmaid_pwa_home_cleaning_cta");

  const buttonLabel = translate("cta_button_label");
  const isFeatureEnabled = useFeatureToggle(
    "pwa_start_booking_floating_button",
  );

  if (
    !isUserStateKnown ||
    isUserLoggedIn ||
    !isFeatureEnabled ||
    featureToggleStatus !== LOADING_STATE.SUCCEEDED ||
    buttonLabel === "cta_button_label"
  ) {
    return null;
  }

  return (
    <ErrorBoundary fallbackUi={() => <React.Fragment />}>
      <React.Suspense>
        <HomeCleaningCTA {...props} />
      </React.Suspense>
    </ErrorBoundary>
  );
};
